import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIe = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 6 3", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#009A44", d: "M0 0h6v3H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M2 0h4v3H2z" }), /* @__PURE__ */ React.createElement("path", { fill: "#FF8200", d: "M4 0h2v3H4z" }));
const ForwardRef = forwardRef(SvgIe);
const Memo = memo(ForwardRef);
export default Memo;
